import { render } from "./Lists.vue?vue&type=template&id=1b94f17e&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=ts"
export * from "./Lists.vue?vue&type=script&lang=ts"

import "./Lists.vue?vue&type=style&index=0&id=1b94f17e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b94f17e"

export default script